import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

const AdminGate = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center text-gray-400 text-sm">
        Verifying credentials...
      </div>
    );
  }

  if (!user) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="admin-gate-login">
        <ShieldAlert className="h-12 w-12 text-[#FFE800] mx-auto mb-4" />
        <h1 className="font-headings text-2xl uppercase tracking-widest text-[#FFE800] mb-2">
          Admin Access Required
        </h1>
        <p className="text-sm text-gray-400">
          You must be signed in with an admin account to access this page.
        </p>
        <a
          href="/login"
          className="inline-block mt-6 bg-[#FFE800] text-black font-headings uppercase tracking-widest py-3 px-8 hover:bg-[#FFD700]"
          data-testid="admin-gate-sign-in"
        >
          Sign In
        </a>
      </div>
    );
  }

  if (!["admin", "master_admin"].includes(user.role)) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="admin-gate-denied">
        <ShieldAlert className="h-12 w-12 text-red-400 mx-auto mb-4" />
        <h1 className="font-headings text-2xl uppercase tracking-widest text-red-400 mb-2">
          Access Denied
        </h1>
        <p className="text-sm text-gray-400">
          Your account does not have admin privileges.
        </p>
      </div>
    );
  }

  return children;
};

export const adminAuthHeaders = () => {
  // Now uses session cookie automatically — this helper is kept
  // for backward compatibility with existing admin API calls
  return {};
};

export default AdminGate;
